import React from 'react';

import { ForgotPasswordForm } from 'src/components/account';
import { AuthPaperBox } from 'src/components/auth';

export const ForgotPasswordPage: React.FC = () => {
  return (
    <AuthPaperBox>
      <ForgotPasswordForm />
    </AuthPaperBox>
  );
};
